<template>
  <div class="success_home">
    <div id="content" class="about_background content">
      <img class="success_top" :src="successTopPic"/>
      <div>
        <img class="success_center" :src="successPic" />
        <div class="text-pass">认证通过，仅供产品演示!</div>
        <div
            class="hint-text"
            v-show="true" 
          >认证次数: {{formLabelAlign.authCount}} 所在城市: {{formLabelAlign.cityName}}
        </div>
        <br/>
        <div
            class="hint-text"
            v-show="formLabelAlign.checkOpenStatus&&formLabelAlign.checkOpenStatus==1"
          >开瓶检测结果: {{formLabelAlign.check}}
        </div>
        <div
            class="hint-text"
            v-show="formLabelAlign.showTemperature"
          >温度检测结果: {{formLabelAlign.temperature}}
        </div>
      </div>

      <el-card class="picture-position" v-show="formLabelAlign.skuPics.length != 0">
        <div v-swiper:mySwiper="swiperOption">
          <div class="swiper-wrapper">
            <div class="swiper-slide" :key="banner" v-for="banner in formLabelAlign.skuPics">
              <div class="swiper-zoom-container"><img height="210px" :src="banner"> </div>         
            </div>
          </div>
          <!-- <div class="swiper-pagination"></div> -->
        </div>
      </el-card>

      <el-card class="content-position no-padding" v-for="(item,index) in groups" :key="index" :style="!(formLabelAlign.skuPics.length != 0)&&index == 0?'margin-top: 16%;':''" :class="item.groupType==null?'hide':''">
        <div class="clearfix header">
          <img class="my_head_background" src="static/product_head.png" />
          <img class="my_head" src="static/product_message.png" />
          <span style="font-family:PingFang">{{item.groupName}}</span>
        </div>
        <el-form
          :label-position="labelPosition"
          label-width="90px"
          v-for="(detailItem,index) in item.groupDetails"
          :key="index"
        >
          <el-form-item :label="detailItem.name">
            <div style="font-weight:700;font-family:PingFang;">{{detailItem.value}}</div>
          </el-form-item>
        </el-form>
      </el-card>
      <div class="bottom" :style="groups.length==0?'margin-top: 16%':''">
        {{i18n.notice}}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import wTitleBar from "@/components/w-titleBar";
import urlParam from '../../../common/url.js';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// import 'swiper/swiper-bundle.css'
import 'swiper/css/swiper.css'
export default {
  name: "wechat",
  components: {
    wTitleBar,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      title: '',
      successPic: "/static/success_center.png",
      responseData: null,
      labelPosition: "left",
      successTopPic: "/static/success_top.png",
      formLabelAlign: {
        skuPics:[],
        checkOpenStatus: 0, // 是否显示开瓶检测
        check: "", // 开瓶检测
        authCount: 0, //认证次数
        cityName: "未知" //所在城市
      },
      swiperOption: {
          autoplay: { 
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          pagination: {
              el: '.swiper-pagination'
          },
      },
      groups:[]
    };
  },
  //beforeCreate → created → computed（首次求值）→ 真实 DOM 生成（渲染页面） → mounted
  created() {
    let cityName = urlParam.getUrlKey('cityName');
    this.formLabelAlign.cityName = cityName;
    let authCount = urlParam.getUrlKey('authCount');
    this.formLabelAlign.authCount = authCount;

    let clientCode = urlParam.getUrlKey('clientParam');
    //多彩
    if(clientCode==="001RR"){
      this.formLabelAlign.skuPics = ["http://22263349.s21i.faiusr.com/2/ABUIABACGAAg2Nn3_QUouOvKmgcwoAY4oAY.jpg","http://22263349.s21i.faiusr.com/2/ABUIABACGAAg08zz_QUo2tyUlAYwoAY4oAY.jpg"];
      this.groups = [{"groupName":"商品信息","groupType":"commonInfo","groupDetails":[{"name":"产品详情","value":"多彩贵州酒（1935）命名含义：纪念贵州茅台镇产区酱香酒奠定中国名酒地位，1935年年红军长征到遵义，四渡赤水出奇兵，第三渡在茅台镇，当地百姓把酱香酒送给红军清洗伤口、喝酒解乏，暂时解决了缺医少药的困难，红军长征胜利也有茅台镇产区酱香酒的功劳。"}]}];
    }
    //国台
    else if(clientCode==="002RR"){
      this.formLabelAlign.skuPics = ["http://www.guotaijiu.com/up_pic/202142217181985301.jpg","http://www.guotaijiu.com/up_pic/2019481414196157.jpg"];
      this.groups = [{"groupName":"商品信息","groupType":"commonInfo","groupDetails":[{"name":"产品详情","value":"百分之百的纯粮酿造，每一粒高粱都精选自当地的优质糯高粱生产基地，优中选优，严格秉承端午制曲 重阳下沙 九次蒸煮 八次发酵 七次取酒 基酒窖藏 盘勾 调勾 品勾 360天酿造一瓶酒，1800天窖藏一瓶酒，每一瓶上市的国台美酒，至少五年方成。"}]}];
    }
    else if(clientCode==="003RR"){
      this.formLabelAlign.skuPics = ["https://wushuang-page.puf.fmsh.com/image/zhen15_1.png","https://wushuang-page.puf.fmsh.com/image/zhen15_2.jpg"];
      this.groups = [{"groupName":"商品信息","groupType":"commonInfo","groupDetails":[{"name":"产品名称","value":"珍酒珍十五"},{"name":"厂家","value":"贵州珍酒酿酒有限公司"},{"name":"产地","value":"贵州省遵义市"},{"name":"度数","value":"53度"},{"name":"香型","value":"酱香型白酒"},{"name":"产品详情","value":"珍十五选用优质糯高粱、小麦、水为原料，采用传统酱香型白酒纯粮固态发酵工艺精心酿造，选用不同年份珍藏老酒和优质基酒匠心勾调而成；未添加任何香气、香味物质，具有酱香突出、陈香舒适、细腻圆润、绵甜味长、空杯留香持久的风格。珍十五饮用时甘甜爽口，感觉激情满怀，饮后神清气爽；属珍酒年份酒系列经典之作。"}]}];
    }
    else if(clientCode==="004RR"){
      this.formLabelAlign.skuPics = ["https://wushuang-page.puf.fmsh.com/image/hongjiu.png","https://wushuang-page.puf.fmsh.com/image/putaojiu.png"];
      this.groups = [{"groupName":"商品信息","groupType":"commonInfo","groupDetails":[{"name":"产品名称","value":"2013 罗伯特·蒙大维酒庄纳帕谷 大势 红混酿（复旦微电子定制）"},{"name":"产品描述","value":"尊贵的朋友，请尽情享用上海复旦微电子集团股份有限公司为您定制的加州罗伯特·蒙大维酒庄葡萄酒。这支2013动力混酿给人各个感官都带来了愉悦感，入口可以感受到黑樱桃、深色辛香料、甜橡木、和细腻的橙子皮的味道。结构坚实，但质地仍然丝滑。余味悠长、愉快。"},{"name":"原料","value":"66%梅洛，31%赤霞珠，2%马尔贝克，1%小维多"},{"name":"生产商","value":"美国加州罗伯特蒙大菲酒庄"},{"name":"经销商","value":"美国加州翔鹰"},{"name":"产地描述","value":"罗伯特·蒙大菲（Robert Mondavi）于1966年建立了他的同名酒庄，其愿景是创造让企业立于世界葡萄酒之巅的纳帕谷葡萄酒。他选择了位于纳帕谷中心的喀龙（To Kalon，古希腊语中意为“最高的美”）葡萄园作为罗伯特·蒙大菲酒庄的所在地。首个耕种的葡萄园位于加利福尼亚州奥克维尔，这里以生产世界上最好的赤霞珠葡萄酒而闻名，同时它的长相思葡萄也蜚声在外，蒙大菲先生用它制作其特色白葡萄酒，白富美（Fumé Blanc）。"},{"name":"产品规格","value":"750mL"},{"name":"酒精度","value":"14.6%"}]}];
    }
    else if(clientCode==="005RR"){
      this.formLabelAlign.skuPics = ["https://wushuang-page.puf.fmsh.com/image/fuping1.jpg","https://wushuang-page.puf.fmsh.com/image/fuping2.jpg"];
      this.groups = [{"groupName":"商品信息","groupType":"commonInfo","groupDetails":[{"name":"产品名称","value":"赤宝砂工艺福瓶"},{"name":"制作工艺","value":"本作品先以德化瓷烧制技艺制成瓷胎，再运用福州脱胎漆器技艺中的“赤宝砂”工艺进行表面装饰，工序二十几道。它是一件摆设品，华丽而不失庄重。"},{"name":"生产商","value":"福州三宝工艺美术研究开发有限公司"},{"name":"产品规格","value":"腹围直径8.6cm 高19cm"},{"name":"制作人信息","value":"许德越，男，福建省福州市闽清县钟石村人，1963年11月生，1985年毕业于兰州大学，1985年从事漆艺工作至今。中国工艺美术协会理事、漆器专业委员会委员，福建省工艺美术协会常务理事、漆艺专业委员会副主任。福建省地方标准——《地理标志产品  福州脱胎漆器》第一起草人，国家标准——《全国漆器通用技术要求》主要制定者之一，《中国地理标志产品大典（福建卷）》编委、撰稿人，《铜胎漆器制作工艺》发明专利获得者。在三十几年的从艺生涯中，无论是在制作漆器，还是从事授徒工作，始终坚守“匠人精神”，至今共授徒100多人。其漆艺作品共二十几次获全国性、省、市奖项。多件漆艺作品被人民大会堂、公安部、首都大酒店、南非国家博物馆、湖南省博物馆、福建省工艺美术珍品馆、福州市博物馆等单位收藏。中央电视台、海峡卫视、台湾东森电视台曾为其制作播出漆艺专题片。从艺期间曾先后担任福州市漆器研究所所长，福州三宝工艺美术研究开发有限公司艺术总监，福州漆艺术研究院首席专家，福建省船政交通职业学院非遗技艺指导教师等职。2013年，被福建省工艺美术学会授予“福建省漆艺大师”荣誉称号。2018年，被福建省工信厅授予“福建省工艺美术名人”荣誉称号。"}]}];
    }
    else if(clientCode==="006RR"){
      this.formLabelAlign.skuPics = ["https://wushuang-page.puf.fmsh.com/image/Milo1.png","https://wushuang-page.puf.fmsh.com/image/Milo2.png"];
      this.groups = [{"groupName":"商品信息","groupType":"commonInfo","groupDetails":[{"name":"产品名称","value":"小狗米鲁互动系列T"},{"name":"总经销商","value":"浙江美声智能系统有限公司"},{"name":"原料","value":"100%有机棉"},{"name":"安全等级","value":"A类"},{"name":"图案","value":"卡通宠物"},{"name":"袖长","value":"短袖"},{"name":"功能","value":"吸湿排汗"}]}];
    }
    else if(clientCode==="007RR"){
      this.formLabelAlign.skuPics = ["https://wushuang-page.puf.fmsh.com/image/chaye1.jpg","https://wushuang-page.puf.fmsh.com/image/chaye2.jpg"];
      this.groups = [{"groupName":"商品信息","groupType":"commonInfo","groupDetails":[{"name":"产品名称","value":"精品茶叶"},{"name":"产地","value":"杭州"},{"name":"品种","value":"绿茶"},{"name":"净重","value":"200g"}]}];
    }
    else if(clientCode==="008RR"){
      this.formLabelAlign.skuPics = ["https://wushuang-page.puf.fmsh.com/image/zhonghua1.jpg","https://wushuang-page.puf.fmsh.com/image/zhonghua2.jpg"];
      this.groups = [{"groupName":"商品信息","groupType":"commonInfo","groupDetails":[{"name":"产品名称","value":"中华牌香烟"},{"name":"产地","value":"上海"},{"name":"规格","value":"97mm 细支"}]}];
    }
    else if(clientCode==="009RR"){
      this.formLabelAlign.skuPics = ["https://wushuang-page.puf.fmsh.com/image/maotai.png","https://wushuang-page.puf.fmsh.com/image/maotai2.png"];
      this.groups = [{"groupName":"商品信息","groupType":"commonInfo","groupDetails":[{"name":"产品名称","value":"贵州茅台酒"},{"name":"原料表","value":"优质糯高粱、小麦、水"},{"name":"生产商","value":"贵州茅台酒股份有限公司"},{"name":"产品规格","value":"500ml"},{"name":"酒精度","value":"53%"},{"name":"口感","value":"酱香突出、幽雅细腻、酒体醇厚、回味悠长，空杯留香持久"},{"name":"文化","value":"茅台酒是中国酱香型白酒代表，多次获国际金奖，被誉为“国酒”，融合历史、工艺与文化传承"}]}];
    }
    else{
      this.formLabelAlign.skuPics = ["https://wushuang-page.puf.fmsh.com/image/hongjiu.png","https://wushuang-page.puf.fmsh.com/image/putaojiu.png"];
      this.groups = [{"groupName":"商品信息","groupType":"commonInfo","groupDetails":[{"name":"产品名称","value":"2013 罗伯特·蒙大维酒庄纳帕谷 大势 红混酿"},{"name":"产品描述","value":"尊贵的朋友，请尽情享用加州罗伯特·蒙大维酒庄葡萄酒。这支2013动力混酿给人各个感官都带来了愉悦感，入口可以感受到黑樱桃、深色辛香料、甜橡木、和细腻的橙子皮的味道。结构坚实，但质地仍然丝滑。余味悠长、愉快。"},{"name":"原料","value":"66%梅洛，31%赤霞珠，2%马尔贝克，1%小维多"},{"name":"生产商","value":"美国加州罗伯特蒙大菲酒庄"},{"name":"经销商","value":"美国加州翔鹰"},{"name":"产地描述","value":"罗伯特·蒙大菲（Robert Mondavi）于1966年建立了他的同名酒庄，其愿景是创造让企业立于世界葡萄酒之巅的纳帕谷葡萄酒。他选择了位于纳帕谷中心的喀龙（To Kalon，古希腊语中意为“最高的美”）葡萄园作为罗伯特·蒙大菲酒庄的所在地。首个耕种的葡萄园位于加利福尼亚州奥克维尔，这里以生产世界上最好的赤霞珠葡萄酒而闻名，同时它的长相思葡萄也蜚声在外，蒙大菲先生用它制作其特色白葡萄酒，白富美（Fumé Blanc）。"},{"name":"产品规格","value":"750mL"},{"name":"酒精度","value":"14.6%"}]}];
    }
    let checkParam = urlParam.getUrlKey('checkParam');
    let checkOpen = checkParam.substring(0,1);
    let openValue = checkParam.substring(1,2);
    if(checkOpen==="Y"){
      this.formLabelAlign.checkOpenStatus = 1;
    }
    else{
      this.formLabelAlign.checkOpenStatus = 0;
    }
    if(openValue==="0"){
      this.formLabelAlign.check = "已开启";
    }
    else{
      this.formLabelAlign.check = "未开启";
    }
    let temperatureParam = urlParam.getUrlKey('temperatureParam');
    if(temperatureParam.length>0){
      this.formLabelAlign.showTemperature = true;
      this.formLabelAlign.temperature = temperatureParam;
    }
    else{
      this.formLabelAlign.showTemperature = false;
      this.formLabelAlign.temperature = "";
    }
  },
  //页面渲染之前执行
  computed: {
    i18n() {
      this.title = this.$t('success.title');
      return this.$t('success');
    }
  },
  //页面渲染之后执行
  mounted() {
    // 计算toolbar高度
    let divContent = document.getElementById("content").clientHeight;
    let screenHeight = document.body.clientHeight;
    document.getElementById("content").style.cssText =
      "height: " + (divContent - 44) + "px;";
  },
  methods: {
    gotoHome() {
      this.$router.back();
    },
    getMessage(e) {
      this.$alert(e, "标题名称", {
        confirmButtonText: "确定",
        callback: (action) => {
          this.$message({
            type: "info",
            message: `action: ${action}`,
          });
        },
      });
    },
    carousel(){
      this.$refs.carousel.setActiveItem(index);
    }
  },
};
</script>

<style lang="less" scoped>
.about_background {
  background-color: #f6f6f6;
}
.content {
  // margin-top: -44px;
  width: 100vw;
  height: 100vh;
  overflow: scroll;
}
.success_top {
  // margin-top: 44px;
  width: 100vw;
}
.success_center {
  // background-image: url(/static/success_center.png); /* 引入图片 */
  // background-size: 100vw; /* 设置图片的大小 */
  // background-repeat: no-repeat;
  // // background-position: 50% -40%;
  // width: 100%;
  // height: 100%;
  // position: absolute;
  // z-index: 3;

  width: 100vw;
  margin-top: -50%;
}
.text-pass {
  margin-top: -38%;
  text-align: center;
  font-size: 20px;
  font-family: PingFang;
  font-weight: 700;
  color: rgba(208, 2, 27, 1);
  line-height: 56px;
}
.text-pass_bottom{
  margin-top: -2%;
  text-align: center;
  font-size: 17px;
  // font-family: PingFang;
  // font-weight: 700;
  // color: rgba(43, 27, 2, 1);
  // line-height: 56px;
}
.hint-text {
  font-size: 15px;
  text-align: center;
  font-family: PingFang;
  font-weight: 500;
  color: rgba(43, 27, 2, 1);
  line-height: 15px;
  // margin-top: 4%;
  // margin-bottom: -9%;
  margin-bottom: -4%;
}
.picture-position {
  margin-top: 16%;
  // margin-top: 22%;
  margin-left: 10px;
  margin-right: 10px;
  height: 250px;
  border-radius: 20px;
}
.image {
  width: 100%;
  display: block;
}
.content-position {
  margin-top: 2%;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;
}
.my_head {
  width: 1.2rem;
  height: 1.2rem;
  margin-right: 5px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
  margin-left: -240px;
}
.my_head_background {
  margin-left: -20px;
  height: 2.2rem;
  margin-right: 5px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}
.header {
  padding: 10px 0px;
  box-sizing: border-box;
  margin-top: -10px;
}
.no-padding {
  padding: 0px;
}
.el-carousel__item img {
  height: 200px;
  clear: both;
  display: block;
  margin: auto;
}
.bottom {
  margin-top: 8px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #C3C3C3;
  font-family:PingFang;
}
.hide{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/wechat/wechat.vue